export const REACTIONABLE_TYPES = {
  BREEDER_POST: 'BreederPost'
};

export const REACTION_TYPES = {
  LIKE: 'like'
};
